




















import { Component, Vue, Watch, Prop } from 'vue-property-decorator'

@Component({})
export default class Controls extends Vue {
  @Prop()
  disabled: boolean

  loading: boolean = false

  vocals: boolean | null = null // TODO: change to values that are future proof
  energy: boolean | null = null

  async start() {
    this.loading = true

    this.$emit('start')

    try {
      this.$store.commit('discovery/setOptions', {
        vocals: this.vocals,
        energy: this.energy
      })

      await this.$store.dispatch('discovery/fetch')

      await this.$router.replace({
        name: 'discovery results'
      })
    } catch (error) {
      console.error(error)

      this.loading = false
    }
  }

  created() {
    this.$store.commit('discovery/reset')
  }

  @Watch('loading')
  watchLoading() {
    this.$emit('update:loading', this.loading)
  }
}
